import { Fragment, useState, useEffect } from 'react';
import RenderInfoLogic from '../../../../../components/InfoSidebar/RenderInfoLogic';

interface ManageGraphsProps {
  sectionTitle: any;
  tab: any;
  view: any;
  source: any;
  names: any;
  searchItems: any;
  title: any;
  Graph?: any;
  setSearchItems: any;
}

function ManageGraphs({
  tab,
  view,
  source,
  names, // Rename to searchItems
  searchItems,
  title, // Better title? ala sectionTitle
  Graph = null, // Not passed, refactor away
  setSearchItems,
}: ManageGraphsProps) {
  let keySearch = '';

  if (searchItems.length > 0) {
    let prefix = '';
    if (title === 'DISEASES') {
      prefix = 'disease=';
      keySearch = `${prefix}${searchItems.map((item: any) => `UMLS_${item.id}`).join(',')}`;
    } else if (title === 'GENES') {
      prefix = 'gene_ncbi_id=';
      keySearch = `${prefix}${searchItems.map((item: any) => item.id).join(',')}`;
    } else if (title === 'VARIANTS') {
      prefix = 'variant=';
      keySearch = `${prefix}${searchItems.map((item: any) => item.id).join(',')}`;
    }
  }

  const defaultChart =
    searchItems.length > 1 || (names.length === 1 && title === 'SummaryVDA' && title === 'GENES')
      ? 'HEATMAP'
      : 'LINE';
  const [selectedChart, setSelectedChart] = useState(defaultChart);

  useEffect(() => {
    if (searchItems.length > 1 || (names.length === 1 && title === 'SummaryVDA' && title === 'GENES')) {
      setSelectedChart('HEATMAP');
    } else {
      setSelectedChart('LINE');
    }
  }, [searchItems, names, title]);

  return (
    <Fragment>
      <div className="Cabtabla mt-3">
        {names && (
          <div className="row items-end justify-start md:justify-end mb-4 md:mb-0">
            <RenderInfoLogic
              searchItems={searchItems}
              selectedInfoItem={null}
              setSearchItems={setSearchItems}
              isMapping={false}
              showModalExample={false}
              setShowModalExample={() => {}}
              hideSearchItemsList
            />
          </div>
        )}
      </div>

      {Graph && (
        <Graph
          source={source}
          tab={tab}
          keySearch={keySearch}
          view={view}
          names={names}
          selectedChart={selectedChart}
          setSearchItems={setSearchItems}
        />
      )}
    </Fragment>
  );
}

export default ManageGraphs;
